export const breakpointLabels = [
    'xs',
    's',
    'm',
    'l',
    'xl',
    'xxl',
];
/**
 * Custom type guard to assert given label is a BreakpointLabel
 *
 * @param {string} label
 */
export function isBreakpointLabel(label) {
    return breakpointLabels.includes(label);
}
//# sourceMappingURL=types.mjs.mjs.map